export const OPPORTUNITY_COLUMNS = [
  { key: "organization", label: "Organizacija", fixed: true },
  { key: "status", label: "Status" },
  { key: "opportunity", label: "Tip prilike" },
  { key: "organizationType", label: "Tip organizacije" },
  { key: "region", label: "Regija" },
  { key: "fit", label: "Fit" },
  { key: "confidence", label: "Pouzdanost" },
  { key: "reasons", label: "Razlozi" },
  { key: "sources", label: "Broj izvora" },
] as const;
export type OpportunityColumnKey = typeof OPPORTUNITY_COLUMNS[number]["key"];
export const DEFAULT_COLUMN_ORDER: OpportunityColumnKey[] = OPPORTUNITY_COLUMNS.map((column) => column.key);
export const DEFAULT_VISIBLE_COLUMNS: OpportunityColumnKey[] = ["organization", "status", "opportunity", "fit", "confidence", "reasons"];
export function OpportunityColumns({ order, visible, onOrder, onVisible, onReset }: {
  order: OpportunityColumnKey[]; visible: OpportunityColumnKey[];
  onOrder: (keys: OpportunityColumnKey[]) => void;
  onVisible: (keys: OpportunityColumnKey[]) => void; onReset: () => void;
}) {
  const move = (index: number, change: number) => {
    const next = [...order]; const target = index + change;
    if (index < 1 || target < 1 || target >= next.length) return;
    [next[index], next[target]] = [next[target], next[index]]; onOrder(next);
  };
  return <details className="rounded border border-border bg-background p-3">
    <summary className="cursor-pointer text-sm font-medium">Stupci i redoslijed</summary>
    <p className="mt-2 text-xs text-muted-foreground">Prilagodite ovaj prikaz. Skrivanje stupca ne briše podatke; organizacija i otvaranje detalja uvijek su dostupni.</p>
    <ul className="mt-3 space-y-2">
      {order.map((key, index) => {
        const column = OPPORTUNITY_COLUMNS.find((entry) => entry.key === key)!;
        return <li key={key} className="flex items-center justify-between gap-3 text-sm">
          <label className="flex items-center gap-2"><input type="checkbox" checked={visible.includes(key)} disabled={key === "organization"} onChange={() => onVisible(visible.includes(key) ? visible.filter((entry) => entry !== key) : [...visible, key])} />{column.label}</label>
          <div className="flex gap-1"><button type="button" className="rounded border border-border px-2 py-1 disabled:opacity-30" aria-label={`Pomakni stupac ${column.label} ranije`} disabled={index <= 1} onClick={() => move(index, -1)}>↑</button><button type="button" className="rounded border border-border px-2 py-1 disabled:opacity-30" aria-label={`Pomakni stupac ${column.label} kasnije`} disabled={index === 0 || index === order.length - 1} onClick={() => move(index, 1)}>↓</button></div>
        </li>;
      })}
    </ul>
    <button type="button" className="mt-3 text-sm underline" onClick={onReset}>Vrati zadane stupce</button>
  </details>;
}
